<div class="modal-overlay" (click)="onClose()">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2>
                <fa-icon [icon]="icons.faCircleInfo"></fa-icon>
                {{ 'RESULT.EXECUTION_DETAILS' | translate }}
            </h2>
            <button class="close-button" (click)="onClose()" [title]="'BUTTON.CANCEL' | translate">
                <fa-icon [icon]="icons.faTimes"></fa-icon>
            </button>
        </div>

        <div class="modal-body">
            @if (loading) {
            <div class="modal-state loading">
                <fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon>
                <p>{{ 'MESSAGE.LOADING.EXECUTION_DETAILS' | translate }}</p>
            </div>
            }

            @if (error && !loading) {
            <div class="modal-state error">
                <fa-icon [icon]="icons.faExclamationTriangle"></fa-icon>
                <p>{{ error | translate }}</p>
            </div>
            }

            @if (!loading && !error && details) {
            <div class="details-container">
                <div class="details-section">
                    <h3 class="section-title">
                        <span class="title-text">{{ 'RESULT.EXECUTION_CONFIG' | translate }}</span>
                    </h3>
                    <div class="config-grid">
                        @if (details.interaction_snapshot.delfos_server_config) {
                        <div class="info-card">
                            <span class="card-label">{{ 'SETTINGS.PREFERENCES.DELFOS_SERVER' | translate }}</span>
                            <span class="card-value">{{ details.interaction_snapshot.delfos_server_config.display_label || details.interaction_snapshot.delfos_server_config.key }}</span>
                        </div>
                        }
                        @if (details.interaction_snapshot.delfos_llm_config) {
                        <div class="info-card">
                            <span class="card-label">{{ 'SETTINGS.PREFERENCES.DELFOS_LLM' | translate }}</span>
                            <span class="card-value">{{ details.interaction_snapshot.delfos_llm_config.display_label || details.interaction_snapshot.delfos_llm_config.key }}</span>
                        </div>
                        }
                        @if (details.interaction_snapshot.di2winocr_server_config) {
                        <div class="info-card">
                            <span class="card-label">{{ 'SETTINGS.PREFERENCES.OCR_SERVER' | translate }}</span>
                            <span class="card-value">{{ details.interaction_snapshot.di2winocr_server_config.display_label || details.interaction_snapshot.di2winocr_server_config.key
                                }}</span>
                        </div>
                        }
                        @if (details.interaction_snapshot.di2winocr_features_config) {
                        <div class="info-card ocr-features-card">
                            <span class="card-label">{{ 'SETTINGS.PREFERENCES.OCR_FEATURES' | translate }}</span>
                            <span class="card-value">
                                <span class="card-value-text">{{
                                    details.interaction_snapshot.di2winocr_features_config.display_label ||
                                    details.interaction_snapshot.di2winocr_features_config.key }}</span>
                                @if (details.interaction_snapshot.di2winocr_features_config.is_customized) {
                                <span class="custom-badge">{{ 'OCR_OVERRIDE.BADGE' | translate }}</span>
                                }
                            </span>
                            <button type="button" class="save-ocr-btn" (click)="openSaveOcrAsNew()">
                                <fa-icon [icon]="icons.faFloppyDisk"></fa-icon>
                                <span>{{ 'RESULT.OCR_SAVE_AS_NEW' | translate }}</span>
                            </button>
                        </div>
                        }

                        <div class="info-card">
                            <span class="card-label">{{ 'SETTINGS.PREFERENCES.AI_MODEL_LANGUAGE' | translate }}</span>
                            <span class="card-value">{{ getLanguageLabelKey(details.execution_config.ai_model_language) | translate }}</span>
                        </div>

                        <div class="info-card">
                            <span class="card-label">{{ 'EXECUTE_MODAL.CLEAR_OCR_CACHE' | translate }}</span>
                            <span class="card-value" [class.highlight]="details.execution_config.clear_di2winocr_cache">
                                {{ (details.execution_config.clear_di2winocr_cache ? 'COMMON.YES' : 'COMMON.NO') |
                                translate }}
                            </span>
                        </div>
                        <div class="info-card">
                            <span class="card-label">{{ 'EXECUTE_MODAL.CLEAR_RESPONSE_CACHE' | translate }}</span>
                            <span class="card-value" [class.highlight]="details.execution_config.clear_delfos_cache">
                                {{ (details.execution_config.clear_delfos_cache ? 'COMMON.YES' : 'COMMON.NO') |
                                translate
                                }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="details-section">
                    <h3 class="section-title">
                        <span class="title-text">{{ 'RESULT.INTERACTION_SNAPSHOT' | translate }}</span>
                    </h3>
                    <div class="snapshot-grid">
                        <div class="info-card">
                            <span class="card-label">{{ 'INTERACTIONS.FORM.NAME' | translate }}</span>
                            <span class="card-value">{{ details.interaction_snapshot.name }}</span>
                        </div>

                        @if (details.interaction_snapshot.model) {
                        <div class="info-card">
                            <span class="card-label">{{ 'SECTION.MODELS' | translate }}</span>
                            <span class="card-value">{{ details.interaction_snapshot.model.name }}</span>
                        </div>
                        }
                    </div>

                    @if (details.interaction_snapshot.archives?.length) {
                    <div class="archives-container">
                        <span class="archives-label">{{ 'SECTION.ARCHIVES' | translate }}</span>
                        <div class="archives-list">
                            @for (archive of details.interaction_snapshot.archives; track archive.id) {
                            <span class="archive-badge">{{ archive.name }}</span>
                            }
                        </div>
                    </div>
                    }
                </div>

                @if (details.token_usage && details.token_usage.total?.total > 0) {
                <div class="details-section">
                    <h3 class="section-title">
                        <span class="title-text">{{ 'RESULT.USAGE_INFO' | translate }}</span>
                    </h3>
                    
                    <div class="usage-summary">
                        <div class="summary-group">
                            <span class="group-title">{{ 'RESULT.TOKENS_TOTAL' | translate }}</span>
                            <div class="usage-grid compact">
                                <div class="info-card usage-card mini">
                                    <span class="card-label">{{ 'RESULT.TOKENS_INPUT' | translate }}</span>
                                    <span class="card-value">{{ details.token_usage.total.input | number }}</span>
                                </div>
                                <div class="info-card usage-card mini">
                                    <span class="card-label">{{ 'RESULT.TOKENS_OUTPUT' | translate }}</span>
                                    <span class="card-value">{{ details.token_usage.total.output | number }}</span>
                                </div>
                                <div class="info-card usage-card mini total">
                                    <span class="card-label">{{ 'RESULT.TOKENS_TOTAL' | translate }}</span>
                                    <span class="card-value">{{ details.token_usage.total.total | number }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="summary-group">
                            <span class="group-title">{{ 'RESULT.TOKENS_AVERAGE' | translate }}</span>
                            <div class="usage-grid compact">
                                <div class="info-card usage-card mini average">
                                    <span class="card-label">{{ 'RESULT.TOKENS_INPUT' | translate }}</span>
                                    <span class="card-value">{{ getAverageTokens('input') | number }}</span>
                                </div>
                                <div class="info-card usage-card mini average">
                                    <span class="card-label">{{ 'RESULT.TOKENS_OUTPUT' | translate }}</span>
                                    <span class="card-value">{{ getAverageTokens('output') | number }}</span>
                                </div>
                                <div class="info-card usage-card mini average total">
                                    <span class="card-label">{{ 'RESULT.TOKENS_TOTAL' | translate }}</span>
                                    <span class="card-value">{{ getAverageTokens('total') | number }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    @if (details.token_usage.per_archive && details.interaction_snapshot.archives?.length > 1) {
                    <div class="usage-details">
                        <div class="details-header">
                            <span class="details-label">{{ 'RESULT.TOKENS_PER_FILE' | translate }}</span>
                            <div class="usage-legend">
                                <span class="legend-item input">
                                    <fa-icon [icon]="icons.faArrowRight"></fa-icon>
                                    {{ 'RESULT.TOKENS_INPUT' | translate }}
                                </span>
                                <span class="legend-item output">
                                    <fa-icon [icon]="icons.faArrowLeft"></fa-icon>
                                    {{ 'RESULT.TOKENS_OUTPUT' | translate }}
                                </span>
                                <span class="legend-item total">
                                    {{ 'RESULT.TOKENS_TOTAL' | translate }}
                                </span>
                            </div>
                        </div>
                        <div class="details-list">
                            @for (archive of details.interaction_snapshot.archives; track archive.id) {
                            @if (getTokensForArchive(archive.id); as tokens) {
                            <div class="detail-row">
                                <span class="archive-name" [title]="archive.name">{{ archive.name }}</span>
                                <div class="token-badges">
                                    <span class="badge input" [title]="'RESULT.TOKENS_INPUT' | translate">
                                        <fa-icon [icon]="icons.faArrowRight"></fa-icon>
                                        {{ tokens.input | number }}
                                    </span>
                                    <span class="badge output" [title]="'RESULT.TOKENS_OUTPUT' | translate">
                                        <fa-icon [icon]="icons.faArrowLeft"></fa-icon>
                                        {{ tokens.output | number }}
                                    </span>
                                    <span class="badge total" [title]="'RESULT.TOKENS_TOTAL' | translate">
                                        {{ tokens.total | number }}
                                    </span>
                                </div>
                            </div>
                            }
                            }
                        </div>
                    </div>
                    }
                </div>
                }
            </div>
            }
        </div>

        <div class="modal-footer">
            <button type="button" class="footer-button" (click)="onClose()">
                {{ 'BUTTON.CANCEL.GENERAL' | translate }}
            </button>
        </div>
    </div>
</div>

<app-modal-create-edit
    [show]="showCreateOcrModal"
    [isEdit]="false"
    [configType]="'di2winocr_features'"
    [prefillValue]="ocrPrefillValue"
    (close)="onCreateOcrClose()"
    (updated)="onOcrConfigCreated()">
</app-modal-create-edit>